"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeeMoreButton = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
exports.testIds = {
    seeMoreIcon: 'see_more-expand_icon',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    expandArrowButton: {
        padding: theme.spacing(0.5),
        fontSize: theme.typography.caption.fontSize,
        marginLeft: theme.spacing(-0.5),
        marginTop: theme.spacing(1.2),
        alignSelf: 'flex-start',
    },
    expandArrowIcon: ({ isExpanded }) => ({
        transform: isExpanded ? 'rotate(180deg)' : 'none',
    }),
}));
const SeeMoreButton = ({ isExpanded, setIsExpanded }) => {
    const classes = useStyles({ isExpanded });
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { endIcon: (0, jsx_runtime_1.jsx)(silhouette_core_1.ExpandMoreIcon, { fontSize: "medium", className: classes.expandArrowIcon, "data-testid": exports.testIds.seeMoreIcon }), onClick: () => setIsExpanded(!isExpanded), className: classes.expandArrowButton, children: isExpanded ? translate('activity_feed-see_less') : translate('activity_feed-see_more') }));
};
exports.SeeMoreButton = SeeMoreButton;
//# sourceMappingURL=SeeMoreButton.js.map